import styled from "styled-components";
import { HTMLAttributes } from "react";

const StyledTableRow = styled.td<HTMLAttributes<HTMLTableCellElement>>`
  padding: 16px 24px;
  border: 1px solid ${(props) => props.theme.palette.neutral4};
  border-right: none;
  word-break: break;
`;

export default StyledTableRow;
